const copyToClipboard = (text, triggerEl) => {
  // Navigator clipboard API needs a secure context (https).
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text);

    // Show a tooltip (if found) for 2 seconds.
    const tooltip = triggerEl.querySelector('.tooltip');

    if (tooltip) {
      tooltip.classList.add('tooltip--visible');
      setTimeout(() => {
        tooltip.classList.remove('tooltip--visible');
      }, 2000);
    }
  }
};

export default copyToClipboard;
